export default __webpack_public_path__ + "static/media/blogs-banner.cea35155.png";